



















































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { ICompany } from '@resclick/data-access';
import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class TabGeneral extends Mixins(ModalTabMixin) {
  form!: CrsForm<'paymentOptionGroups', 'create' | 'update'>;
  @Getter('user/currentCompany') currentCompany!: string;

  getForm() {
    return compass.do('paymentOptionGroups', 'findById', {
      params: { paymentOptionGroupId: this.id as string },
    });
  }

  created() {
    this.form = this.$crsForm('paymentOptionGroups', this.mode, {
      isActive: false,
      isDefault: false,
      name: '',
      company: this.currentCompany,
    });

    this.$once('update-data', (data: ICompany) => {
      this.form = this.$crsForm('paymentOptionGroups', 'update', data);
    });
  }
}
